import type { PublicEvent, RoleBucket, VolunteerRole } from "../../shared/types";
import { bucketOf } from "../../shared/types";

const WEEKDAYS = ["日", "一", "二", "三", "四", "五", "六"];

export function weekdayOf(dateISO: string | null): string {
  if (!dateISO) return "";
  const d = new Date(dateISO + "T00:00:00+08:00");
  if (Number.isNaN(d.getTime())) return "";
  return "週" + WEEKDAYS[d.getDay()];
}

export function formatDate(dateISO: string | null): string {
  if (!dateISO) return "日期待確認";
  const [y, m, d] = dateISO.split("-");
  return `${y}/${m}/${d}`;
}

export function monthLabel(monthGroup: string): string {
  const [y, m] = monthGroup.split("-");
  return `${y} 年 ${Number(m)} 月`;
}

/** 場次對某 bucket 的名額狀態。 */
export function capacityFor(e: PublicEvent, bucket: RoleBucket) {
  const cap = bucket === "seed" ? e.capacitySeed : e.capacityActivity;
  const confirmed = bucket === "seed" ? e.confirmedSeed : e.confirmedActivity;
  const waitlist = bucket === "seed" ? e.waitlistSeed : e.waitlistActivity;
  const remaining = cap == null ? null : Math.max(0, cap - confirmed);
  const full = cap != null && confirmed >= cap;
  return { cap, confirmed, waitlist, remaining, full };
}

export interface HoursSummary {
  morningCount: number;
  charityCount: number;
  totalHours: number;
  remaining: number;
  met: boolean;
  /** 依目前身分推估，已勾選場次中會被列遞補的數量。 */
  projectedWaitlist: number;
}

export function computeSummary(
  events: PublicEvent[],
  selectedIds: Set<number>,
  minHours: number,
  roles: VolunteerRole[],
): HoursSummary {
  const bucket = bucketOf(roles);
  let morningCount = 0;
  let charityCount = 0;
  let totalHours = 0;
  let projectedWaitlist = 0;
  for (const e of events) {
    if (!selectedIds.has(e.id)) continue;
    if (e.category === "charity") charityCount++;
    else morningCount++;
    totalHours += e.creditHours;
    if (capacityFor(e, bucket).full) projectedWaitlist++;
  }
  totalHours = Math.round(totalHours * 10) / 10;
  const remaining = Math.max(0, Math.round((minHours - totalHours) * 10) / 10);
  return {
    morningCount,
    charityCount,
    totalHours,
    remaining,
    met: totalHours >= minHours,
    projectedWaitlist,
  };
}

export const LOCATION_FILTERS: Array<{ key: string; label: string; match: (e: PublicEvent) => boolean }> = [
  { key: "all", label: "全部場次", match: () => true },
  { key: "daoxiang", label: "AR伴讀-稻香國小", match: (e) => e.locationKey === "daoxiang" },
  { key: "jian", label: "AR伴讀-吉安國小", match: (e) => e.locationKey === "jian" },
  { key: "charity", label: "星星國-公益活動", match: (e) => e.category === "charity" },
];
